import { Routes } from '@angular/router';
import { mobileStaffAuthGuard } from '@ew-mobile/mobile-staff-guards';

export const staffPortalRoutes: Routes = [
  {
    path: 'staff/login',
    loadComponent: async () =>
      (await import('@ew-mobile/mobile-staff-auth')).MobileStaffLoginComponent,
  },
  {
    path: 'staff/portal',
    loadComponent: async () =>
      (await import('@ew-mobile/mobile-staff-portal')).MobileStaffPortalComponent,
    canActivate: [mobileStaffAuthGuard],
  },
];
